import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { CapabilityEngineService } from '../capabilityEngine.service';
import { UserProfileComponent } from '../user-profile/user-profile.component';
import { UserRoleDegradeComponent } from '../user-role-degrade/user-role-degrade.component';
import { UsersListService } from './users-list.service';
import {MatRadioModule} from '@angular/material/radio';

@Component({
    selector: 'app-user-list',
    templateUrl: './users-list.component.html',
    styleUrls: ['./users-list.component.scss'],
})
export class UsersListComponent implements OnInit {

    sortKey: String;
    sortOrder: String;
    usersList: any;
    pageNumber: number = 0;
    nextToken: String;
    curNextToken: String;
    showUserDetails: Boolean = false;
    originalUserDetails: any = {};
    displayDetails: any = {};
    updatedDetails: any = {};
    errMsg = '';
    successMsg = '';
    searchText = '';
    // emptyrole: String;
    // imageValue;
    assets:any = {};
    selectedAssets = {};
    isSupervisorDeactivated = false;
    assetsDropdownSettings = {
        singleSelection: false,
        text: "Select Assets",
        selectAllText: 'Select All',
        unSelectAllText: 'Deselect All',
        enableSearchFilter: true,
        classes: "myclass custom-class",
        labelKey: "name",
        maxHeight: 200,
        enableFilterSelectAll: false
    };
    assetSelectedItems: any = {};
    isSelectedTrue = false;

    operatorsList: any = [];
    selectedOperators: any = [];
    operatorsDropdownSettings = {
        singleSelection: false,
        text: "Select Operator(s)",
        selectAllText: 'Select All Operators',
        unSelectAllText: 'Deselect All Operators',
        enableSearchFilter: true,
        classes: "myclass custom-class",
        labelKey: "name",
        maxHeight: 200,
        enableFilterSelectAll: false
    };
    presentUserRole = "";
    supervisorsList = []
    assigneeSupervisor = {};
    isCountryChanged: boolean = false;
    constructor(
        private _usersListService: UsersListService,
        private _capabilityEngineService: CapabilityEngineService,
        private _activatedRoute: ActivatedRoute,
        private modalService: NgbModal,
    ) { }

    ngOnInit() {
        const pathData = this._activatedRoute.data['_value'];
        if (this.canPerform(pathData.capabilities)) {
            this.sortKey = 'name';
            this.sortOrder = 'asc';
            this.onScroll();
        }
        this._usersListService.assetsList().subscribe(
            (result: any) => {
                this.assets = result.data;
                _.forEach(Object.keys(this.assets), (assetKey) => {

                    this.assets[assetKey] = _.map(this.assets[assetKey], (asset) => { asset.id = asset._id; return asset; })
                })
            }
        );
    }

    sort(key) {
        if (key === this.sortKey) {
            this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortKey = key;
            this.sortOrder = 'asc';
        }
    }

    canPerform(data) {
        return this._capabilityEngineService.canPerform(data);
    }

    onScroll() {
        this._usersListService.performPagination(this.pageNumber)
            .subscribe((result: any) => {

                let currentTeamId = localStorage.getItem("teamId");
                if (!this.usersList) {
                    this.usersList = result.data;
                    _.forEach(this.usersList, (user) => {
                        // _.forEach(user.teams, (team) => {
                        //     const userTeamName = team.teamDetails.name.toLowerCase();
                        //     if (userTeamName === localStorage.getItem('teamName').toLowerCase()) {
                        //         user.userStatus = team.userStatus;
                        //         user.assets = team.assets;
                        //     }
                        // });
                        let team = _.find(user.teams, (team) => {
                            return team.teamDetails._id == currentTeamId
                        })
                        if(team) {
                            user.userStatus = team.userStatus;
                            user.assets = team.assets;
                        }
                    });
                } else {
                    this.usersList = _.union(this.usersList, result.data);
                    _.forEach(this.usersList, (user) => {
                        // _.forEach(user.teams, (team) => {
                        //     const userTeamName = team.teamDetails.name.toLowerCase();
                        //     if (userTeamName === localStorage.getItem('teamName').toLowerCase()) {
                        //         user.userStatus = team.userStatus;
                        //         user.assets = team.assets;
                        //     }
                        // });
                        let team = _.find(user.teams, (team) => {
                            return team.teamDetails._id == currentTeamId
                        })
                        if(team) {
                            user.userStatus = team.userStatus;
                            user.assets = team.assets;
                        }
                    });
                }
                this.pageNumber++;
                this.updateOperatorsList()
                this.updateSupervisorsList()
            });
    }
    openUserProfileModal = () => {
        const modalRef = this.modalService.open(UserProfileComponent);
    }
    openUserDegradeModal = () => {
        const modalRef = this.modalService.open(UserRoleDegradeComponent);
    }

    toggleDisplay(_userDetails: any = {}) {
        this.errMsg = "";
        this.isCountryChanged = false;
        this.assigneeSupervisor = {}
        if (_userDetails) {
            this.originalUserDetails = _userDetails ? _userDetails : {};
            this.displayDetails = _.clone(this.originalUserDetails);
            if(_userDetails['role'] == "supervisor" || _userDetails['role'] == "webAdmin") {
                if(_userDetails['userStatus'] == true) {
                    this.isSupervisorDeactivated = false
                } else {
                    this.isSupervisorDeactivated = true
                }
            }
        } else {
            if (this.displayDetails.userStatusClass === 'deactivated') {
                this.originalUserDetails.userStatus = false;
            } else {
                this.originalUserDetails.userStatus = true;
            }
        }

        if (_userDetails['assets'] && Object.keys(_userDetails['assets']).length > 0) {
            this.selectedAssets = _userDetails['assets'];
            this.assetSelectedItems = {};
            _.forEach(Object.keys(this.selectedAssets), (assetKey) => {
                _.forEach((this.selectedAssets[assetKey]), (subAssetKey) => {
                    if (this.assetSelectedItems[assetKey]) {
                        this.assetSelectedItems[assetKey] = [...this.assetSelectedItems[assetKey], ...(_.filter(this.assets[assetKey], (assetData) => {return assetData.id === subAssetKey}))]
                    } else {
                        this.assetSelectedItems[assetKey] = (_.filter(this.assets[assetKey], (assetData) => {return assetData.id === subAssetKey}));
                    }
                })
            });
        }
        if(this.displayDetails.role == "supervisor" || this.displayDetails.role == "webAdmin") {
            this.updateSupervisorsList(_userDetails);
            const teamIndex = _userDetails['teams'].findIndex(team => team.teamDetails._id == localStorage.getItem('teamId'))
            if(_userDetails['teams'][teamIndex]['operators'] && _userDetails['teams'][teamIndex]['operators'].length) {
                this.selectedOperators = _userDetails['teams'][teamIndex]['operators']
                _.map(this.selectedOperators, (operator) => {
                    operator['id'] = operator['_id']
                })
            } else {
                this.selectedOperators = []
            }
        }


        this.displayDetails.phone = this.displayDetails.phone ? this.displayDetails.phone : '';
        this.showUserDetails = !this.showUserDetails;
        this.presentUserRole = this.displayDetails.role
        this.updatedDetails = {
            _id: this.displayDetails._id,
            email: this.displayDetails.email,
            name: undefined,
            role: undefined,
            phone: undefined,
            userStatus: undefined
        };

        if (this.displayDetails.userStatus === true && !this.displayDetails.verificationCode) {
            this.displayDetails.userStatus = 'active';
            this.displayDetails.userStatusClass = 'active'; // Make sure it is the same as above(i.e userStatus === userStatusClass) for following 4 options
        } else if (!this.displayDetails.verificationCode && this.displayDetails.userStatus === false) {
            this.displayDetails.userStatus = 'deactivated';
            this.displayDetails.userStatusClass = 'deactivated';
        } else if (this.displayDetails.verificationCode && this.displayDetails.verificationCode !== 'cancelled' && this.displayDetails.userStatus === true) {
            this.displayDetails.userStatus = 'invited';
            this.displayDetails.userStatusClass = 'invited';
        } else if (this.displayDetails.verificationCode && this.displayDetails.verificationCode === 'cancelled' && this.displayDetails.userStatus === true) {
            this.displayDetails.userStatus = 'invitationCancelled';
            this.displayDetails.userStatusClass = 'invitationCancelled';
        }
        let phoneInput = document.querySelector(`#user-phone`);
        // init plugin
        let win: any = window;
        let iti = win.intlTelInput(phoneInput, {
            utilsScript: '../../build/js/utils.js?1537727621611' // just for formatting/placeholders etc
        });

        let thisInstance = this;
        // // listen to the telephone input for changes
        phoneInput.addEventListener('countrychange', function (e) {
            thisInstance.updatedDetails.countryCode = iti.getSelectedCountryData().dialCode;
            thisInstance.isCountryChanged = true;
        });
    }



    checkForAnyUpdates() {
        this.selectInputFields();
        if (this.updatedDetails.role || this.updatedDetails.userStatus ||
            (this.originalUserDetails.name !== this.displayDetails.name) ||
            (this.originalUserDetails.phone !== this.displayDetails.phone) || (this.originalUserDetails.password !== this.displayDetails.password) || (this.originalUserDetails.email !== this.displayDetails.email) || this.isSelectedTrue) {
            // this.successMsg = '';
            // this.errMsg = '';
            return true;
        } else {
            return false;
        }
    }

    selectInputFields() {
        this.updatedDetails.name = (this.originalUserDetails.name !== this.displayDetails.name) ? this.displayDetails.name : undefined;
        this.updatedDetails.phone = (this.originalUserDetails.phone !== this.displayDetails.phone) ? this.displayDetails.phone : undefined;
    }

    selectRole(_role) {
        this.updatedDetails.role = this.displayDetails.role !== _role ? _role : undefined;
        // if (previousRole === 'webAdmin' && _role === 'supervisor') {
        //     this.openUserDegradeModal();
        // } else if (previousRole === 'webAdmin' && _role === 'operator') {
        //     this.openUserDegradeModal();
        // } else if (previousRole === 'supervisor' && _role === 'operator') {
        //     this.openUserDegradeModal();
        // } else {
        //     this.emptyrole = '';
        // }
    }

    checkIfCurrentUser() {
        if (localStorage.getItem('userEmail') === this.originalUserDetails.email) {
            console.log(this.originalUserDetails.email);
            return true;
        }
        return false;
    }

    selectUserStatus(_status) {
        console.log('TCL: UsersListComponent -> selectUserStatus -> _status', _status);

        if (_status === 'deactivated' && this.checkIfCurrentUser()) {
            return;
        } else {
            this.updatedDetails.userStatus = _status;
            this.displayDetails.userStatusClass = _status;
            if(this.displayDetails['role'] == 'supervisor') {
                if(_status == 'reactivate') {
                    this.isSupervisorDeactivated = false;
                } else {
                    this.isSupervisorDeactivated = true;
                }
            }
        }
    }

    undoSelectedUserStatus() {
        this.updatedDetails.userStatus = undefined;
        console.log('TCL: UsersListComponent -> undoSelectedUserStatus -> this.displayDetails', this.displayDetails);
        this.displayDetails.userStatusClass = this.displayDetails.userStatus;
        this.isSupervisorDeactivated = !this.isSupervisorDeactivated
    }

    updateDetails() {

        if (!this.checkForAnyUpdates()) {
            return;
        }
        if(this.displayDetails.password && this.displayDetails.password.length < 8) {
            return;
        }
        this.updatedDetails.phone = !this.updatedDetails.phone ? undefined : this.updatedDetails.phone; // Check if phone is empty or not.
        if(this.isCountryChanged) {
            if(!_.isEmpty(this.updatedDetails.phone)) {
                this.updatedDetails.phone = '+' + this.updatedDetails.countryCode + this.updatedDetails.phone.toString()
            }
        }
        var obj = {
            _id: this.updatedDetails._id,
            email: this.updatedDetails.email,
            name: this.updatedDetails.name,
            role: this.updatedDetails.role === this.displayDetails.role ? undefined : this.updatedDetails.role,
            phone: this.updatedDetails.phone,
            userStatus: this.updatedDetails.userStatus,  // reinvite |  cancelInvite |  deactivate | reactivate
            password: this.displayDetails.password && this.displayDetails.password.length ? this.displayDetails.password : undefined
        };

        // Check if email is changed or not
        
        if(this.displayDetails.email !== this.updatedDetails.email) {
            obj['newEmail'] = this.displayDetails['email'];
            obj['email'] = this.updatedDetails['email'];

            let userEmailIndex = _.findIndex(this.usersList, (user: any)=> {
                return user.email === obj['newEmail'];
            })

            if(userEmailIndex !== -1) {
                this.errMsg = "User with the given emaill already exists.";
                return;
            }
        }

        if (this.selectedAssets && Object.keys(this.selectedAssets).length > 0) {
            obj['assets'] = this.selectedAssets;
        }

        if((this.displayDetails.role == "supervisor" || this.displayDetails.role == "webAdmin") && this.selectedOperators && this.selectedOperators.length > 0) {
            obj['operators'] = []
            _.forEach(this.selectedOperators, (operator) => {
                let tempOperator = {
                    _id: operator._id,
                    name: operator.name
                }
                obj['operators'].push(tempOperator)
            })
            if(this.assigneeSupervisor && this.assigneeSupervisor['name']) {
                obj['assigneeSupervisor'] = this.assigneeSupervisor;
            }
        } else if((this.displayDetails.role == "supervisor" || this.displayDetails.role == "webAdmin") && (!this.selectedOperators || this.selectedOperators.length == 0)) {
            obj['operators'] = []
        }

        this._usersListService.updateUserDetails(obj)
            .subscribe((result: any) => {

                this.originalUserDetails.name = obj.name ? obj.name : this.originalUserDetails.name;
                this.originalUserDetails.role = obj.role ? obj.role : this.originalUserDetails.role;
                this.originalUserDetails.phone = obj.phone ? obj.phone : this.originalUserDetails.phone;
                this.originalUserDetails.userStatus = obj.userStatus ? obj.userStatus : this.originalUserDetails.userStatus;
                this.successMsg = 'The changes are successfully updated';
                this.assigneeSupervisor = {}

                if(this.displayDetails.role == "webAdmin" && this.checkIfCurrentUser()) {
                    let localStorageTeamDetails = localStorage.getItem("teams") ? JSON.parse(localStorage.getItem("teams")) : [];
                    let presentTeamIndex = _.findIndex(localStorageTeamDetails, (team) => {
                        if(team['teamDetails'] && team['teamDetails']["_id"] && team['teamDetails']["_id"] == localStorage.getItem("teamId")) {
                            return true;
                        }
                    })
                    if(presentTeamIndex > -1){ 
                        localStorageTeamDetails[presentTeamIndex]["operators"] = obj["operators"];
                    }
                    localStorage.setItem("teams", JSON.stringify(localStorageTeamDetails))
                }
                setTimeout(() => {
                    this.successMsg = '';
                    this.pageNumber = 0;
                    this.usersList = []
                    this.onScroll();
                    this.showUserDetails = !this.showUserDetails;
                }, 1200);
            }
                , (err) => {
                    this.errMsg = 'The network connection has lost. Please try updating it again.';
                    if(err.status === 400 && err.error && err.error.message) {
                        this.errMsg = err.error.message;
                    }
                    setTimeout(() => {
                        this.errMsg = '';
                    }, 5000);
                });
    }
    // getFirstLetterString(name) {
    //     let result = '';
    //     let splitArray = name.split(' ');
    //     if (name.length === 1) {
    //         result = name;
    //     } else if (splitArray.length === 1) {
    //         result = splitArray[0][0] + splitArray[0][1];
    //     } else {
    //         _.forEach(splitArray, function (word) {
    //             result = result.concat(word[0]);
    //         });
    //     }

    //     return result.substring(0, 2);
    // }
    // imageDisplay(x) {
    //     this.imageValue = x;
    //     console.log(this.imageValue);
    // }
    onSelectAll(event) {
        this.isSelectedTrue = true;
        this.selectedAssets = {};
        _.forEach(this.assets['main'], (asset) => {
            var subAssets = [];
            _.forEach(this.assets[asset._id], (subAsset) => {
                subAssets.push(subAsset._id);
            })
            this.selectedAssets[asset._id] = subAssets;
        })
    }
    onDeSelectAll(event) {
        this.isSelectedTrue = true;
        this.selectedAssets = {};
    }
    onItemSelect(event) {
        this.isSelectedTrue = true;
        if (this.selectedAssets[event.assetId]) {
            if (this.selectedAssets[event.assetId].includes(event._id)) {
                const index = this.selectedAssets[event.assetId].indexOf(event._id);
                if (index > -1) {
                    (this.selectedAssets[event.assetId]).splice(index, 1);
                }

            } else {
                var assets = this.selectedAssets[event.assetId];
                assets.push(event._id);
                this.selectedAssets[event.assetId] = assets;
            }
        } else {
            this.selectedAssets[event.assetId] = [event._id];
        }
    }

    OnItemDeSelect(event) {
        this.isSelectedTrue = true;
        if (this.selectedAssets[event.assetId]) {
            if (this.selectedAssets[event.assetId].includes(event._id)) {
                const index = this.selectedAssets[event.assetId].indexOf(event._id);
                if (index > -1) {
                    (this.selectedAssets[event.assetId]).splice(index, 1);
                }

            } else {
                var assets = this.selectedAssets[event.assetId];
                assets.push(event._id);
                this.selectedAssets[event.assetId] = assets;
            }
        } else {
            this.selectedAssets[event.assetId] = [event._id];
        }
    }

    isFormhound(){
        return this._capabilityEngineService.isFormhound();
     }

    isOshaMshaForm(){
        return this._capabilityEngineService.isOshaMshaForm();
    }

    updateOperatorsList() {
        this.operatorsList = _.filter(this.usersList, user => user.role == "operator" && user.userStatus == true && !user.verificationCode)
        _.map(this.operatorsList, (operator) => {
            operator['id'] = operator['_id']
        })
    }

    onOperatorSelect(operator) {
        this.isSelectedTrue = true;
    }

    onOperatorDeSelect(operator) {
        this.isSelectedTrue = true;
    }

    onOperatorsSelectAll(operators) {
        this.isSelectedTrue = true;
    }

    onOperatorsDeSelectAll() {
        this.isSelectedTrue = true;
        this.selectedOperators = []
    }

    updateSupervisorsList(user?) {
        this.supervisorsList = _.filter(this.usersList, user => user.role == "supervisor" && user.userStatus == true && !user.verificationCode)
        if(user && user.role == 'supervisor') {
            this.supervisorsList = _.filter(this.supervisorsList, tempUser => tempUser._id != user._id)
        }
    }
    assignNewSuperVisor(supervisor) {
        this.assigneeSupervisor['name']=supervisor.name; 
        this.assigneeSupervisor['_id']=supervisor._id;
        this.assigneeSupervisor['email']=supervisor.email;

        console.log(this.assigneeSupervisor)
    }
}



// WEBPACK FOOTER //
// ./src/app/users-list/users-list.component.ts